import { FetchContext } from '../fetch-context';
import { AwardCountryStatistic } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getCountryAwardStatistic: (
  fetchContext: FetchContext,
  programId: number,
  countryId: number,
  accessToken?: string,
) => Promise<AwardCountryStatistic> = (fetchContext, programId, countryId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/statistic`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<AwardCountryStatistic>(fetchContext.errorStore, response, 'get country award statistic'));
